import {
  aggregateData,
  cleanedData,
  convertTonsToKilograms,
  defaultState,
  findInEnums,
  getUniqueNextSites,
  optimizeColumns,
  productTypeList,
  siteCodes,
} from '../components/common';
import {
  apply,
  exportExcel,
  queryGapVolume2,
  querySummaryCount,
  queryWaybillNoByRoute,
  selectAdjustRemarkBaseList,
  selectList,
  checkNextStation,
  checkTicketAvgWeight
} from '@/services/temporaryRouteRequest';

import { message } from 'antd';
import uniqBy from 'lodash/uniqBy';

export default {
  namespace: 'temporaryRouteRequest',
  state: {
    ...defaultState,
    activeKey: 'outboundRequest', // 默认选中key:outboundRequest
    tempSearchParams: {
      outboundRequestArriveSite: {},
      outboundRequestAdjustSite: {},
      inboundRequestArriveSite: {},
      inboundRequestAdjustSite: {},
    },
    forecastAdjustRemark: [], // 路由调整原因枚举
    arriveSite: {}, // 调整后下一站
    adjustSite: {}, // 调整前下一站
    departureCenter: {
      isCenter: false,
      site: {},
      // 申请分拨
      code: '', // 分拨编码
      name: '', // 分拨名称
    },
    checkResult: {}, // 校验结果
    // 分拨信息
    access: {},
    // 组织信息
    organization: {},
    summaryCount: {
      unArriveWeightCount: 0,
      flowYesCount: 0,
      flowNoCount: 0,
      flowOther: 0,
    }, // 聚合汇总
    isAreaAuth: false, // 用于关闭抽屉后做请求权限标识
  },
  effects: {
    //重置状态
    *rest(_, { put }) {
      yield put({
        type: 'updateData',
        payload: {
          ...defaultState,
          // departureCenter: {
          //   // 申请分拨
          //   code: '', // 分拨编码
          //   name: '', // 分拨名称
          // },
          // // 分拨信息
          // access: {},
        },
      });
    },
    /**
     * 获取审计备注信息
     *
     * @param _ - 未使用的参数
     * @param {Object} actions - 包含了 call 和 put 的对象
     * @param {Function} actions.call - 调用其他 generator 函数或异步函数的函数
     * @param {Function} actions.put - 发送 action 到 redux store 的函数
     * @returns {void}
     */

    *getforecastAdjustRemark(_, { call, put }) {
      try {
        const { data = [] } = yield call(selectAdjustRemarkBaseList, {});
        const forecastAdjustRemark = data.map((item) => ({
          ...item,
          value: item.key,
          label: item.value,
        }));
        yield put({
          type: 'updateData',
          payload: {
            forecastAdjustRemark,
          },
        });
      } catch (error) {
        // 错误处理
      }
    },
    /**
     * 根据路由查询运单号
     *
     * @param {{payload: any}} obj - 包含payload属性的对象，payload中包含了查询所需的参数
     * @param {{call: Function}} context - 包含了call函数的上下文对象，call用于调用其他saga或者异步操作
     * @returns {void} 无返回值
     */
    *queryWaybillNoByRoute({ payload, callback }, { call, put }) {
      if (payload.searchFlag) {
        message.error(`请选择下一站`);
        return;
      }
      delete payload.searchFlag;
      delete payload.adjustSite;
      delete payload.arriveSite;
      yield put({
        type: 'updateData',
        payload: {
          tableLoding: true,
        },
      });
      try {
        const cleanPayload = cleanedData(payload);
        const { data = [] } = yield call(queryWaybillNoByRoute, cleanPayload);

        if (callback) {
          callback(data);
          const noWaybillNoArray = data
            .filter(
              (item) =>
                !cleanPayload.tranConsolidationNum.some((tranNum) => tranNum === item.waybillNo),
            )
            .map((item) => item.waybillNo);

          // const noWaybillNo =
          //   Array.isArray(noWaybillNoArray) && noWaybillNoArray.length > 0
          //     ? noWaybillNoArray.join(',')
          //     : '';
          yield put({
            type: 'updateData',
            payload: {
              noWaybillNo: noWaybillNoArray,
            },
          });
        } else {
          yield put({
            type: 'updateData',
            payload: {
              leftFilterTable: data,
            },
          });
        }
      } catch (error) {
        // 错误处理
      }
      yield put({
        type: 'updateData',
        payload: {
          tableLoding: false,
        },
      });
    },
    /**
     * 更新左侧筛选区的值
     *
     * @param {{payload: any}} obj - 包含需要更新的参数的对象
     * @param {{put: Function}} context - 包含了put函数的上下文对象
     * @returns {void}
     */
    *updateLeftFilter({ payload }, { put, select }) {
      const state = yield select((state) => state.temporaryRouteRequest);
      // 合并当前的 leftFilter 和 payload
      const updatedLeftFilter = { ...state.leftFilter, ...payload };
      // 更新 state
      yield put({
        type: 'updateData',
        payload: {
          leftFilter: updatedLeftFilter,
        },
      });
    },
    /**
     * 根据运单号查询数据
     *
     * @param {object} payload - 查询参数
     * @param {object} effects - effects 对象，包含 call, put, select 方法
     * @param {Function} effects.call - 调用异步函数的 effect
     * @param {Function} effects.put - 触发 action 的 effect
     * @param {Function} effects.select - 获取全局 state 的 effect
     * @returns {void}
     */
    *selectByOrderNo({ payload, callback }, { call, put, select }) {
      const state = yield select((state) => state.temporaryRouteRequest);
      const { departureCenter, rightFilterTable } = state;
      if (payload.searchFlag) {
        message.error(`请输入运单号`);
        return;
      }
      delete payload.searchFlag;
      delete payload.adjustSite;
      delete payload.arriveSite;
      delete payload.inputRangeNumber;
      const applyPayload = {
        ...payload,
        departureSiteCode: departureCenter?.code,
      };
      if (!applyPayload.departureSiteCode) {
        message.error(`仅限分拨账户使用`);
        return;
      }
      try {
        const { data = [] } = yield call(queryWaybillNoByRoute, applyPayload);

        // 检查 payload.tranConsolidationNum 中的每个运单号是否存在于 data 的 waybillNo 中
        const noWaybillNo = payload.tranConsolidationNum.filter(
          (num) => !data.some((item) => item.waybillNo === num),
        );

        // 将新数据与现有数据合并
        const newRightFilterTable = [...rightFilterTable, ...data];

        // 使用 uniqBy 移除重复项
        const uniqueRightFilterTable = uniqBy(newRightFilterTable, 'waybillNo');

        yield put({
          type: 'updateData',
          payload: {
            rightFilterTable: uniqueRightFilterTable,
            noWaybillNo,
          },
        });
        callback && callback();
      } catch (error) {
        // 错误处理
      }
    },
    /**
     * 路由申请
     *
     * @param {Object} payload - 负载对象
     * @param {Function} callback - 回调函数
     * @param {Object} effects - effects 对象，包含 call、select、put 方法
     * @returns {void}
     */
    *apply({ payload, callback }, { call, select, put }) {
      const state = yield select((state) => state.temporaryRouteRequest);
      const { rightFilterTable = [], departureCenter, arriveSite, leftFilter = {}, tempSearchParams = {}, queryInfo = {}, activeKey = 'outboundRequest' } = state;

      // 先调用票均重校验
      const adjustDetailVosForCheck = rightFilterTable.map((item) => ({
        ...item,
        adjustNum: Number(item.totalPiece),
        adjustCalcWeight: Number(item.calcWeight),
        adjustGoodsWeight: Number(item.goodsWeight),
        adjustVolume: Number(item.goodsVolume),
        arriveSiteCode: item.destCenterCode,
        arriveSiteName: item.destCenterName,
        goodsTypeName: findInEnums(productTypeList, 'value', item.productTypeCode)?.label,
        goodsTypeCode: item.productTypeCode,
        inventoryTime: item.instockTime,
        nextSiteCode: item.nextSiteCode,
        nextSiteName: item.nextSiteName,
        tranConsolidationNum: item.waybillNo,
        prevSiteName: item.prevSiteName,
        prevSiteCode: item.prevSiteCode,
        centerSiteName: item.centerSiteName,
        centerSiteCode: item.centerSiteCode,
        sendCenterCode: item.sendCenterCode,
        sendCenterName: item.sendCenterName,
      }));

      const { nextSiteCodeStr, nextSiteNameStr } = getUniqueNextSites(rightFilterTable);
      const arriveWeight = aggregateData(rightFilterTable).total.totalWeight;
      const adjustWeightSource = payload.adjustWeight ?? queryInfo.adjustWeight ?? 0;
      const checkParams = {
        ...queryInfo,
        ...payload,
        adjustDetailVos: adjustDetailVosForCheck,
        departureSiteCode: departureCenter?.code,
        departureSiteName: departureCenter?.name,
        adjustSiteCode: nextSiteCodeStr,
        adjustSiteName: nextSiteNameStr,
        arriveWeight,
        adjustWeight: convertTonsToKilograms(adjustWeightSource || 0),
      };

      const cachedArriveSite = tempSearchParams?.[`${activeKey}arriveSite`] ?? {};
      const leftArriveSiteCodes =
        siteCodes(leftFilter?.arriveSite ?? [], 'code') ||
        siteCodes(leftFilter?.arriveSite ?? [], 'siteTypeCode');
      const leftArriveSiteNames =
        siteCodes(leftFilter?.arriveSite ?? [], 'name') ||
        siteCodes(leftFilter?.arriveSite ?? [], 'siteName');

      if (!checkParams.arriveSiteCode) {
        checkParams.arriveSiteCode =
          payload.arriveSiteCode ??
          queryInfo.arriveSiteCode ??
          arriveSite?.code ??
          cachedArriveSite?.code ??
          leftFilter?.arriveSiteCode ??
          (leftArriveSiteCodes || undefined);
      }
      if (!checkParams.arriveSiteName) {
        checkParams.arriveSiteName =
          payload.arriveSiteName ??
          queryInfo.arriveSiteName ??
          arriveSite?.name ??
          cachedArriveSite?.name ??
          leftFilter?.arriveSiteName ??
          (leftArriveSiteNames || undefined);
      }
      if (!checkParams.arriveSiteCode && adjustDetailVosForCheck.length) {
        checkParams.arriveSiteCode =
          adjustDetailVosForCheck[0]?.arriveSiteCode ??
          adjustDetailVosForCheck[0]?.nextSiteCode ??
          adjustDetailVosForCheck[0]?.destCenterCode;
      }
      if (!checkParams.arriveSiteName && adjustDetailVosForCheck.length) {
        checkParams.arriveSiteName =
          adjustDetailVosForCheck[0]?.arriveSiteName ??
          adjustDetailVosForCheck[0]?.nextSiteName ??
          adjustDetailVosForCheck[0]?.destCenterName;
      }

      if (!checkParams.adjustSiteCode) {
        const leftAdjustSiteCodes =
          siteCodes(leftFilter?.adjustSite ?? [], 'code') ||
          siteCodes(leftFilter?.adjustSite ?? [], 'siteTypeCode');
        checkParams.adjustSiteCode = leftAdjustSiteCodes || checkParams.adjustSiteCode;
      }
      if (!checkParams.adjustSiteName) {
        const leftAdjustSiteNames =
          siteCodes(leftFilter?.adjustSite ?? [], 'name') ||
          siteCodes(leftFilter?.adjustSite ?? [], 'siteName');
        checkParams.adjustSiteName = leftAdjustSiteNames || checkParams.adjustSiteName;
      }

      delete checkParams.rightFilterTable;

      const checkResult = yield call(checkTicketAvgWeight, checkParams);
      console.log(checkResult, 'checkResult in apply');

      // 如果校验失败且包含"标准"关键字,直接提示并返回
      if (checkResult && checkResult.message && checkResult.message.length > 4) {
        message.error(checkResult.message);
        return;
      }

      // const totalCalcWeight = calcWeightBy(rightFilterTable);
      // const totalCalcLeftWeight = calcWeightBy(leftFilterTable);
      const adjustDetailVos = rightFilterTable.map((e) => ({
        ...e,
        adjustNum: Number(e.totalPiece), //				-调整件数
        adjustCalcWeight: Number(e.calcWeight), //			-调整重量 结重(kg)
        adjustGoodsWeight: Number(e.goodsWeight), //			-调整开单重量(kg)
        adjustVolume: Number(e.goodsVolume), //	-调整体积
        arriveSiteCode: e.destCenterCode, //		-目的分拨编号
        arriveSiteName: e.destCenterName, //目的分拨名称
        goodsTypeName: findInEnums(productTypeList, 'value', e.productTypeCode)?.label, //		-产品类别名称
        goodsTypeCode: e.productTypeCode, //		-产品类别编码
        inventoryTime: e.instockTime, //	-入库时间
        nextSiteCode: e.nextSiteCode, //-下一站编号
        nextSiteName: e.nextSiteName, //-下一站名称
        tranConsolidationNum: e.waybillNo, //		-运单号
        prevSiteName: e.prevSiteName, //上一站名称
        prevSiteCode: e.prevSiteCode, //		-上一站编码
        centerSiteName: e.centerSiteName, //		-当前站名称
        centerSiteCode: e.centerSiteCode, //当前站编码
        sendCenterCode: e.sendCenterCode,
        sendCenterName: e.sendCenterName,
      }));
      const uniqueNextSites = getUniqueNextSites(rightFilterTable);
      const adjustSiteCode = uniqueNextSites.nextSiteCodeStr;
      console.log('🚀 ~ *apply ~ adjustSiteCode:', adjustSiteCode);
      const adjustSiteName = uniqueNextSites.nextSiteNameStr;
      console.log('🚀 ~ *apply ~ adjustSiteName:', adjustSiteName);

      // 校验 adjustSiteCode 是否超过 6 个
      if (adjustSiteCode.split(',').length > 6) {
        message.error(`已选货物下一站方向数不能超过6个上限，请调整！`);
        return;
      }

      const applyPayload = {
        ...payload,
        adjustDetailVos,
        departureSiteCode: departureCenter?.code, // 申请分拨编号
        departureSiteName: departureCenter?.name, // 申请分拨名称
        // adjustSiteCode: siteCodes(leftFilter.adjustSite, 'code'), // 调整前下一站编号
        // adjustSiteName: siteCodes(leftFilter.adjustSite, 'name'), // 调整前下一站名称
        adjustSiteCode,
        adjustSiteName,
        // arriveSiteCode: siteCodes(leftFilter.arriveSite, 'code'), // 调整后下一站编号
        // arriveSiteName: siteCodes(leftFilter.arriveSite, 'name'), // 调整后下一站名称
        // arriveWeight: Number(totalCalcLeftWeight.minus(totalCalcWeight)), // 调整后重量
        arriveWeight, // 使用前面计算的 arriveWeight
        adjustWeight: convertTonsToKilograms(payload.adjustWeight), // 调整前重量 吨转换为千克
      };
      if (!applyPayload.departureSiteCode) {
        message.error(`仅限分拨账户使用`);
        return;
      }
      console.log(departureCenter, 'departureCenter');
      console.log(applyPayload.departureSiteCode, 'applyPayload.departureSiteCode');
      const { data = { value: '1' } } = yield call(checkNextStation);
      console.log(data.value, 'checkNextSite');
      // .临时路由申请，在输入调整后下一站光标移开后校验输入的下一站是否和申请分拨是同一个，如果是则弹出提示“调整后下一站不可以是自己”，光标移动到调整下一站输入框中
      if (applyPayload.arriveSiteCode === applyPayload.departureSiteCode) {
        message.error(`调整后下一站不可以是自己`);
        return;
      }
      if (applyPayload.arriveSiteCode && adjustDetailVos.length) {
        console.log(applyPayload.arriveSiteCode, 'applyPayload.arriveSiteCode');
        console.log(adjustDetailVos, 'adjustDetailVos');
        const hasSameSite = adjustDetailVos.some(
          (detail) => detail.nextSiteCode === applyPayload?.arriveSiteCode,
        );
        console.log(hasSameSite, 'hasSameSite');
        if (hasSameSite && data.value !== '1') {
          message.error(`调整前和调整后下一站不可以是相同的`);
          return;
        }
      }
      try {
        const data = yield call(apply, applyPayload);
        if (data.code === 1) {
          message.success(data.message);
          if (callback) callback(data);
        }
      } catch (error) {
        // 错误处理
      }
    },
    /**
     * 申请临时路由（不进行checkTicketAvgWeight校验）
     *
     * @param payload 负载对象
     * @param callback 回调函数
     * @param call 调用函数
     * @param select 选择函数
     * @param put 派发action的函数
     * @returns 无返回值
     */
    * applyWithoutCheck({ payload, callback }, { call, select, put }) {
      const state = yield select((state) => state.temporaryRouteRequest);
      const { rightFilterTable = [], departureCenter, arriveSite, leftFilter = {}, tempSearchParams = {}, queryInfo = {}, activeKey = 'outboundRequest' } = state;

      // 直接构建申请参数，跳过checkTicketAvgWeight校验
      const { nextSiteCodeStr, nextSiteNameStr } = getUniqueNextSites(rightFilterTable);
      const arriveWeight = aggregateData(rightFilterTable).total.totalWeight;
      const adjustWeightSource = payload.adjustWeight ?? queryInfo.adjustWeight ?? 0;

      const adjustDetailVos = rightFilterTable.map((e) => ({
        ...e,
        adjustNum: Number(e.totalPiece), //				-调整件数
        adjustCalcWeight: Number(e.calcWeight), //			-调整重量 结重(kg)
        adjustGoodsWeight: Number(e.goodsWeight), //			-调整开单重量(kg)
        adjustVolume: Number(e.goodsVolume), //	-调整体积
        arriveSiteCode: e.destCenterCode, //		-目的分拨编号
        arriveSiteName: e.destCenterName, //目的分拨名称
        goodsTypeName: findInEnums(productTypeList, 'value', e.productTypeCode)?.label, //		-产品类别名称
        goodsTypeCode: e.productTypeCode, //		-产品类别编码
        inventoryTime: e.instockTime, //	-入库时间
        nextSiteCode: e.nextSiteCode, //-下一站编号
        nextSiteName: e.nextSiteName, //-下一站名称
        tranConsolidationNum: e.waybillNo, //		-运单号
        prevSiteName: e.prevSiteName, //上一站名称
        prevSiteCode: e.prevSiteCode, //		-上一站编码
        centerSiteName: e.centerSiteName, //		-当前站名称
        centerSiteCode: e.centerSiteCode, //当前站编码
        sendCenterCode: e.sendCenterCode, //		-发站编码
        sendCenterName: e.sendCenterName, //发站名称
      }));

      const applyPayload = {
        ...payload,
        adjustDetailVos,
        departureSiteCode: departureCenter?.code, //		-申请分拨编号
        departureSiteName: departureCenter?.name, //申请分拨名称
        adjustSiteCode: nextSiteCodeStr, //调整前下一站编号
        adjustSiteName: nextSiteNameStr, //调整前下一站名称
        // adjustSiteCode: siteCodes(leftFilter.adjustSite, 'code'), //调整前下一站编号
        // adjustSiteName: siteCodes(leftFilter.adjustSite, 'name'), // 调整前下一站名称
        // arriveSiteCode: siteCodes(leftFilter.arriveSite, 'code'), // 调整后下一站编号
        // arriveSiteName: siteCodes(leftFilter.arriveSite, 'name'), // 调整后下一站名称
        arriveWeight, // 使用前面计算的 arriveWeight
        adjustWeight: convertTonsToKilograms(adjustWeightSource), // 调整前重量 吨转换为千克
      };

      if (!applyPayload.departureSiteCode) {
        message.error(`仅限分拨账户使用`);
        return;
      }

      const { data = { value: '1' } } = yield call(checkNextStation);
      // .临时路由申请，在输入调整后下一站光标移开后校验输入的下一站是否和申请分拨是同一个，如果是则弹出提示"调整后下一站不可以是自己"，光标移动到调整下一站输入框中
      if (applyPayload.arriveSiteCode === applyPayload.departureSiteCode) {
        message.error(`调整后下一站不可以是自己`);
        return;
      }
      if (applyPayload.arriveSiteCode && adjustDetailVos.length) {
        const hasSameSite = adjustDetailVos.some(
          (detail) => detail.nextSiteCode === applyPayload?.arriveSiteCode,
        );
        if (hasSameSite && data.value !== '1') {
          message.error(`调整前和调整后下一站不可以是相同的`);
          return;
        }
      }

      try {
        const data = yield call(apply, applyPayload);
        if (data.code === 1) {
          message.success(data.message);
          if (callback) callback(data);
        }
      } catch (error) {
        // 错误处理
      }
    },
    /**
     * 返回原路由
     *
     * @param payload 负载对象
     * @param callback 回调函数
     * @param call 调用函数
     * @param select 选择函数
     * @returns 无返回值
     */
    * onBackToOriginalRoute({ payload, callback }, { put, select }) {
      yield put({
        type: 'rest',
      });
    },

    /**
     * 查询列表
     *
     * @param payload 查询参数
     * @param put 派发action的函数
     * @param call 调用异步函数的函数
     * @returns 无返回值
     */
    * selectList({ payload, callback }, { put, call }) {
      const { data = [] } = yield call(selectList, payload);
      yield put({
        type: 'updateData',
        payload: {
          rightFilterTable: data,
        },
      });
      if (callback) callback(data);
    },

    /**
     * 查询统计数量
     *
     * @param {Object} payload - 查询参数
     * @param {Function} call - 用于调用异步函数的方法
     * @param {Function} put - 用于分发 action 的方法
     * @returns {Generator<*, void, *>}
     */
    * querySummaryCount({ payload }, { put, call }) {
      const defaultSummaryCount = {
        unArriveWeightCount: 0,
        flowYesCount: 0,
        flowNoCount: 0,
        flowOther: 0,
        alArriveWeightCount: 0,
        arriveWeightCount: 0,
        ticketCountCount: 0,
      };

      try {
        const { data = {} } = yield call(querySummaryCount, payload);
        const summaryCount = {
          unArriveWeightCount: data.unArriveWeightCount ?? defaultSummaryCount.unArriveWeightCount,
          flowYesCount: data.flowYesCount ?? defaultSummaryCount.flowYesCount,
          flowNoCount: data.flowNoCount ?? defaultSummaryCount.flowNoCount,
          flowOther: data.flowOther ?? defaultSummaryCount.flowOther,
          alArriveWeightCount: data.alArriveWeightCount ?? defaultSummaryCount.alArriveWeightCount,
          arriveWeightCount: data.arriveWeightCount ?? defaultSummaryCount.arriveWeightCount,
          ticketCountCount: data.ticketCountCount ?? defaultSummaryCount.ticketCountCount,
        };

        yield put({
          type: 'updateData',
          payload: { summaryCount },
        });
      } catch (error) {
        // 在出错时使用默认值
        yield put({
          type: 'updateData',
          payload: { summaryCount: defaultSummaryCount },
        });
      }
    },

    /**
     * 查询差量体积函数2
     *
     * @param param0 查询参数
     * @param param1 Saga 中间件提供的参数对象
     * @param param1.put 发送 action 的函数
     * @param param1.call 调用异步函数的函数
     * @param param1.select 选择 state 中数据的函数
     * @returns 无返回值
     */
    * queryGapVolume2({ payload }, { put, call, select }) {
      try {
        const state = yield select((state) => state.temporaryRouteRequest);
        const response = yield call(queryGapVolume2, payload);
        const dataArray = Array.isArray(response.data) ? response.data : [];
        const data = dataArray.length > 0 ? dataArray[0] : { gapVolumeBig2: null };
        const adjustedWeight = data.gapVolumeBig2 > 0 ? Math.abs(data.gapVolumeBig2) : 0;

        const updatedQueryInfo = {
          ...state.queryInfo,
          adjustWeight: adjustedWeight,
        };
        yield put({
          type: 'updateData',
          payload: {
            queryInfo: updatedQueryInfo,
          },
        });
      } catch (error) {
        console.error('Error in queryGapVolume2:', error);
        // 处理错误，例如发送错误信息
      }
    },
    * checkTicketAvgWeight({ payload = {}, callback }, { call, select, put }) {
      const state = yield select((state) => state.temporaryRouteRequest);
      const {
        departureCenter = {},
        queryInfo = {},
        arriveSite = {},
        leftFilter = {},
        tempSearchParams = {},
        activeKey = 'outboundRequest',
      } = state;
      yield put({
        type: 'updateData',
        payload: {
          checkResult: {},
        },
      });
      const currentRightFilterTable = payload.rightFilterTable ?? state.rightFilterTable ?? [];

      const adjustDetailVos = currentRightFilterTable.map((item) => ({
        ...item,
        adjustNum: Number(item.totalPiece),
        adjustCalcWeight: Number(item.calcWeight),
        adjustGoodsWeight: Number(item.goodsWeight),
        adjustVolume: Number(item.goodsVolume),
        arriveSiteCode: item.destCenterCode,
        arriveSiteName: item.destCenterName,
        goodsTypeName: findInEnums(productTypeList, 'value', item.productTypeCode)?.label,
        goodsTypeCode: item.productTypeCode,
        inventoryTime: item.instockTime,
        nextSiteCode: item.nextSiteCode,
        nextSiteName: item.nextSiteName,
        tranConsolidationNum: item.waybillNo,
        prevSiteName: item.prevSiteName,
        prevSiteCode: item.prevSiteCode,
        centerSiteName: item.centerSiteName,
        centerSiteCode: item.centerSiteCode,
        sendCenterCode: item.sendCenterCode,
        sendCenterName: item.sendCenterName,
      }));

      const { nextSiteCodeStr, nextSiteNameStr } = getUniqueNextSites(currentRightFilterTable);
      const arriveWeight = aggregateData(currentRightFilterTable).total.totalWeight;
      const adjustWeightSource = payload.adjustWeight ?? queryInfo.adjustWeight ?? 0;
      const params = {
        ...queryInfo,
        ...payload,
        adjustDetailVos,
        departureSiteCode: departureCenter?.code,
        departureSiteName: departureCenter?.name,
        adjustSiteCode: nextSiteCodeStr,
        adjustSiteName: nextSiteNameStr,
        arriveWeight,
        adjustWeight: convertTonsToKilograms(adjustWeightSource || 0),
      };

      const cachedArriveSite = tempSearchParams?.[`${activeKey}arriveSite`] ?? {};
      const leftArriveSiteCodes =
        siteCodes(leftFilter?.arriveSite ?? [], 'code') ||
        siteCodes(leftFilter?.arriveSite ?? [], 'siteTypeCode');
      const leftArriveSiteNames =
        siteCodes(leftFilter?.arriveSite ?? [], 'name') ||
        siteCodes(leftFilter?.arriveSite ?? [], 'siteName');

      if (!params.arriveSiteCode) {
        params.arriveSiteCode =
          payload.arriveSiteCode ??
          queryInfo.arriveSiteCode ??
          arriveSite?.code ??
          cachedArriveSite?.code ??
          leftFilter?.arriveSiteCode ??
          (leftArriveSiteCodes || undefined);
      }
      if (!params.arriveSiteName) {
        params.arriveSiteName =
          payload.arriveSiteName ??
          queryInfo.arriveSiteName ??
          arriveSite?.name ??
          cachedArriveSite?.name ??
          leftFilter?.arriveSiteName ??
          (leftArriveSiteNames || undefined);
      }
      if (!params.arriveSiteCode && adjustDetailVos.length) {
        params.arriveSiteCode =
          adjustDetailVos[0]?.arriveSiteCode ??
          adjustDetailVos[0]?.nextSiteCode ??
          adjustDetailVos[0]?.destCenterCode;
      }
      if (!params.arriveSiteName && adjustDetailVos.length) {
        params.arriveSiteName =
          adjustDetailVos[0]?.arriveSiteName ??
          adjustDetailVos[0]?.nextSiteName ??
          adjustDetailVos[0]?.destCenterName;
      }

      if (!params.adjustSiteCode) {
        const leftAdjustSiteCodes =
          siteCodes(leftFilter?.adjustSite ?? [], 'code') ||
          siteCodes(leftFilter?.adjustSite ?? [], 'siteTypeCode');
        params.adjustSiteCode = leftAdjustSiteCodes || params.adjustSiteCode;
      }
      if (!params.adjustSiteName) {
        const leftAdjustSiteNames =
          siteCodes(leftFilter?.adjustSite ?? [], 'name') ||
          siteCodes(leftFilter?.adjustSite ?? [], 'siteName');
        params.adjustSiteName = leftAdjustSiteNames || params.adjustSiteName;
      }

      delete params.rightFilterTable;

      const checkResult = yield call(checkTicketAvgWeight, params);
      yield put({
        type: 'updateData',
        payload: {
          checkResult: checkResult,
        },
      });
      console.log(checkResult, 'checkResult');
      callback?.();
    },
    /**
     * 更新数据的saga函数
     *
     * @param payload 传入的数据负载
     * @param call 调用其他异步操作的effect
     * @param put 发送action的effect
     * @returns 无返回值
     */
    *export({ payload }, { call, put, select }) {
      const state = yield select((state) => state.temporaryRouteRequest);
      console.log('🚀 ~ *export ~ state:', state.queryFilter);
      try {
        const { queryFilter = {}, activeKey } = state;
        const params = {
          columns: optimizeColumns(payload.choiceColumns),
          adjustWeightStatus: queryFilter?.adjustWeightStatus,
          auditStatus: queryFilter?.auditStatus,
          // "departureProvinceCode": [],
          departureSiteCode: queryFilter?.departureSiteCode,
          departureSiteName: queryFilter?.departureSiteName,
          endTime: queryFilter?.endTime,
          startTime: queryFilter?.startTime,
          arriveSiteName: queryFilter?.arriveSiteName,
          arriveSiteCode: queryFilter?.arriveSiteCode,
          adjustSiteName: queryFilter?.adjustSiteName,
          adjustSiteCode: queryFilter?.adjustSiteCode,
          queryType: activeKey === 'outboundRequest' ? '1' : '2',
        };
        // 如果是别人调给我的 删除 arriveSiteCode 和 arriveSiteName
        if (params?.queryType === '2') {
          delete params.departureSiteCode;
          delete params.departureSiteName;
        }

        const result = yield call(exportExcel, params);

        if (result?.code === 1) {
          message.success('导出成功');
          yield put({
            type: 'updateData',
            payload: {
              exportVisible: false,
            },
          });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },
  },
  reducers: {
    updateData(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
